import { toast } from 'sonner';
import { toApiError, useApi, type PropertyFileResponse } from '@/shared/api';

/** Lädt eine Akte-Datei als Blob und stößt den Browser-Download an. */
export function useAkteFileDownload(propertyId: string) {
  const api = useApi();

  return function download(f: PropertyFileResponse) {
    api.propertyFiles
      .download(propertyId, f.id)
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = f.fileName;
        a.click();
        URL.revokeObjectURL(url);
      })
      .catch(async (err: unknown) =>
        toast.error((await toApiError(err)).detail ?? 'Download fehlgeschlagen'),
      );
  };
}
